import React from "react";

import Explore_Places_Top from "../../../../assets/Explore_Places_Top.png";
import Explore_Places_Bottom from "../../../../assets/Explore_Places_Bottom.png";
import Dots from "../../../../assets/Local_shoping_dots.png";

import Classes from "./Style.module.css";

const Index = () => {
  return (
    <div className={Classes.section2}>
      <div className={Classes.section2_left}>
        <div>
          <img
            className={Classes.section2_left_image}
            alt="Hotel"
            src={Explore_Places_Top}
          />
          <img className={Classes.section2_left_dots} alt="Dots" src={Dots} />
          <img
            className={`${Classes.section2_left_image} ${Classes.second}`}
            alt="Hotel Alt"
            src={Explore_Places_Bottom}
          />
        </div>
      </div>
      <div className={Classes.section2_right}>
        <h1>Explore Places</h1>
        <h2>Local Shopping, Dining, & Entertainment</h2>
        <p>
          Ogunquit has a number of interesting shops offering antiques, rare
          books and other items. Ogunquit has a lovely walking village with
          dozens of boutiques and interesting shops. This coastal area is also
          famous for restaurants, from casual to fine dining, as well as great
          comedy clubs. Enjoy a show at the renowned{" "}
          <a href="#">Ogunquit Playhouse </a> or live music at one of the local
          venues.
        </p>
        <div className={Classes.section_button}>
          <button className="btn_primary alter" style={{ marginRight: "2rem" }}>
            CALL NOW
          </button>
          <button className="btn_primary">BOOK NOW</button>
        </div>
      </div>
    </div>
  );
};

export default Index;
